import { getAccessToken } from "./AuthenticationService";
import config from "../config";

export function createSettingDefaultAction(type) {
  return () => {
    return { type: type };
  };
}

export async function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const errorObj = await response.json();
  return Promise.reject(errorObj);
}

export async function parseJSON(response) {
  return await response.json();
}

export function getApiUrl() {
  return config.apiUrl;
}
export function getPhpApiUrl() {
  return config.phpApiUrl;
}

export function getNewsApiUrl() {
  return config.newsApiUrl;
}

export function getNewsApiKey() {
  return config.newsApiKey;
}

export function getProductApiUrl() {
  return config.apiUrl;
}

export function getHeaderForAjax() {
  return new Headers({
    "Content-Type": "application/json",
    token: getAccessToken(),
  });
}



// WEBPACK FOOTER //
// ./src/services/ServiceHelper.js